var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcademic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6057 4.27356L8.10575 0.77356C8.03875 0.74231 7.96125 0.74231 7.89425 0.77356L0.39425 4.27356C0.30625 4.31456 0.25 4.40281 0.25 4.50006C0.25 4.59731 0.30625 4.68556 0.39425 4.72656L7.89425 8.22656C7.92775 8.24231 7.96375 8.25006 8 8.25006C8.03625 8.25006 8.07225 8.24231 8.10575 8.22656L10.75 6.99256V13.4201L9.5465 15.1048C9.49225 15.1811 9.48475 15.2811 9.52775 15.3646C9.5705 15.4478 9.65625 15.5001 9.75 15.5001H12.25C12.3437 15.5001 12.4295 15.4478 12.4722 15.3646C12.515 15.2811 12.5077 15.1811 12.4535 15.1048L11.25 13.4201V6.75931L15.6057 4.72656C15.6937 4.68556 15.75 4.59731 15.75 4.50006C15.75 4.40281 15.6937 4.31456 15.6057 4.27356Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 7.77781L8.31725 8.67981C8.21875 8.72556 8.109 8.75006 8 8.75006C7.891 8.75006 7.78125 8.72556 7.6825 8.67981L2.75 6.37781V10.5001C2.75 11.9018 5.056 13.0001 8 13.0001C8.811 13.0001 9.57075 12.9143 10.25 12.7641V7.77781Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 7.07781V12.2648C12.6815 11.8158 13.25 11.1956 13.25 10.5001V6.37756L11.75 7.07781Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademic);
export default __webpack_public_path__ + "static/media/academic.b3ade2bb9de05e81d72229420970680b.svg";
export { ForwardRef as ReactComponent };